// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADD_NEXT_PHOTO = "Pridaj \u010fal\u0161ie";
